import React /*, { useState }*/ from "react";
import { Card, Button, Accordion } from "@mantine/core";
import {
  getFlightHours,
  getFlightMinutes,
  getFlightDuration,
  getStop,
} from "../../../helpers/flights";
import { FlightOfferSegment } from "./index";
import "../../../output.css";
import fetchFareOptionsQuery from "../../../queries/fetchFareOptions";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { Box, Typography } from "@mui/material";
import { colors } from "../../../configs";
const FlightOffer = ({ nextSlice, offer, index, selectFlight }: any) => {
  const firstFlight = offer.slices[0];

  const originSegment = firstFlight ? firstFlight.segments[0] : null;
  const originTime = firstFlight ? originSegment.departing_at : null;

  const destinationSegment = firstFlight
    ? firstFlight.segments[firstFlight.segments.length - 1]
    : null;
  const destinationTime = firstFlight ? destinationSegment.arriving_at : null;

  const localSelectFlight = (e: any) => {
    e.preventDefault();
    selectFlight(e, nextSlice, index, offer);
  };

  const orig =
    firstFlight && firstFlight.segments.length > 1
      ? firstFlight.segments[0]
      : null;
  const dest =
    firstFlight && firstFlight.segments.length > 1
      ? firstFlight.segments[1]
      : null;

  const origDest =
    orig !== null && dest !== null
      ? `${getFlightDuration(orig.arriving_at, dest.departing_at)} ${
          orig.destination.iata_code
        }`
      : null;

  const fetchFaresOptions = (
    partId: string,
    slice1Id: string,
    slice2Id: string
  ) => {
    fetchFareOptionsQuery(partId, slice1Id, slice2Id)
      .then((response: any) => response.json())
      .then((data: any) => {
        console.log("offer response in select flight ", data);
        const dataFetc = {
          offer: data.data.data,
        };
      })
      .catch((err) => {
        console.log("djedou err", err);
      });
  };
  return (
    <>
      <Accordion.Item value={offer.id}>
        <Accordion.Control>
          <Box
            sx={{
              height: "125px",
              backgroundColor: "#FFFFFF",
              border: "0.5px solid gray",
              display: "flex",
              flexDirection: "row",
              borderRadius: "12px",
              marginBottom: "5px",
              padding: "5px",
            }}>
            {/* companies box */}
            <Box
              sx={{
                flex: 2.5,
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
              }}>
              <img
                style={{
                  width: "40px",
                  height: "40px",
                  margin: "15px",
                }}
                src={offer.owner.logo_symbol_url}
                alt={offer.owner.logo_lockup_url}
              />
              <Box
                sx={{
                  margin: "15px",
                }}>
                <div>
                  <p>{`${getFlightHours(originTime)}:${getFlightMinutes(
                    originTime
                  )} - ${getFlightHours(destinationTime)}:${getFlightMinutes(
                    destinationTime
                  )}`}</p>
                </div>
                <Typography variant="body1" component="code">
                  {offer.owner.name}
                </Typography>
              </Box>
            </Box>
            {/* duration and stops box */}
            <Box
              sx={{
                flex: 2,
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 5,
              }}>
              <div>
                <p>{`${getFlightDuration(originTime, destinationTime)}`}</p>
                <Typography variant="body1" component="code">
                  {originSegment.origin.iata_code}
                  {"-"}
                  {destinationSegment.destination.iata_code}
                </Typography>
              </div>
              <div>
                <p>{`${getStop(
                  firstFlight ? firstFlight.segments.length : 0
                )}`}</p>
                <Typography variant="body1" component="code">
                  {origDest}
                </Typography>
              </div>
            </Box>
            {/* button and prices boxes */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-end",
                backgroundColor: "#eeeeee",
                padding: "15px",
                gap: 2,
              }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                }}>
                <p>from</p>
                <p>{`€${offer.total_amount}`}</p>
              </div>
              <Button
                sx={{
                  minHeight: "40px",
                }}
                fullWidth
                onClick={localSelectFlight}
                className="bg-blue-500 mb-1"
                variant="gradient">
                <Typography
                  variant="body2"
                  component="b"
                  sx={{
                    marginRight: "35px",
                  }}>
                  Select
                </Typography>

                <ArrowRightAltIcon />
              </Button>
            </Box>
          </Box>
        </Accordion.Control>
        <Accordion.Panel>
          {firstFlight &&
            firstFlight.segments.map((seg: any, index: any) => {
              const orig =
                firstFlight.segments.length > 1 && index !== 0
                  ? firstFlight.segments[index - 1].arriving_at
                  : null;
              const dest =
                firstFlight.segments.length > 1 && index !== 0
                  ? firstFlight.segments[index].departing_at
                  : null;

              return (
                <FlightOfferSegment
                  key={index}
                  segment={seg}
                  orig={orig}
                  dest={dest}
                />
              );
            })}
        </Accordion.Panel>
      </Accordion.Item>
    </>
  );
};

export default FlightOffer;
